import { z } from "zod";
// =============================================================================
// BOOKING ENUMS (mirror GET /api/v2/bookings' BookingDto exactly)
// =============================================================================
export const BookingSourceSchema = z.enum(["ITINERARY", "DIRECT", "EXTERNAL"]);
export const BookingReservationStatusSchema = z.enum([
    "PENDING_CONFIRMATION",
    "CONFIRMED",
    "CANCELLED",
]);
export const BookingFulfillmentStatusSchema = z.enum([
    "PENDING",
    "ACKNOWLEDGED",
    "IN_PROGRESS",
    "COMPLETED",
    "CANCELLED",
]);
// =============================================================================
// BOOKING
// =============================================================================
export const ReservationBookingSchema = z.object({
    id: z.string(),
    source: BookingSourceSchema,
    ownerOrgId: z.number(),
    providerOrgId: z.number(),
    serviceId: z.number(),
    serviceSlotId: z.number(),
    customerId: z.number(),
    itineraryId: z.number().nullable(),
    externalSource: z.string().nullable(),
    externalReference: z.string().nullable(),
    serviceName: z.string(),
    providerName: z.string(),
    customerName: z.string(),
    customerEmail: z.string(),
    customerPhone: z.string().nullable(),
    startsAt: z.string(),
    endsAt: z.string(),
    timezone: z.string(),
    partySize: z.number(),
    reservationStatus: BookingReservationStatusSchema,
    fulfillmentStatus: BookingFulfillmentStatusSchema,
    notes: z.string().nullable(),
    fulfillmentNotes: z.string().nullable(),
    version: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    // Optional so DIRECT/EXTERNAL rows (and older payloads) still parse.
    customFieldValues: z.record(z.string(), z.unknown()).nullable().optional(),
    serviceTypeCode: z.string().nullable().optional(),
});
// =============================================================================
// FILTERS
// =============================================================================
export const ReservationFiltersSchema = z.object({
    source: BookingSourceSchema.nullable().default(null),
    reservationStatus: BookingReservationStatusSchema.nullable().default(null),
    fulfillmentStatus: BookingFulfillmentStatusSchema.nullable().default(null),
    serviceId: z.number().nullable().default(null),
});
export const defaultReservationFilters = {
    source: null,
    reservationStatus: null,
    fulfillmentStatus: null,
    serviceId: null,
};
